import {
  useAllProducts,
  useLabCurrency,
  useOrder,
} from '@witmetrics/data-store';
import { formatPrice } from '@witmetrics/utils/strings';
import { groupOrderProducts } from '@witmetrics/utils/products';
import { findById } from '@witmetrics/utils/arrays';
import type { GroupedOrderProduct } from '@witmetrics/utils';
import { classes, formatOrderProduct } from './utils';

export type OrderInfoProps = {
  orderId: number;
};

export default function OrderInfo({ orderId }: OrderInfoProps) {
  const order = useOrder(orderId);
  const currency = useLabCurrency(order?.labId);
  const products = useAllProducts();

  const renderProductLabel = (op: GroupedOrderProduct) => {
    const product = findById(products, op.productId);
    return product ? product.name : '--';
  };

  if (!order) return null;

  const orderProducts = groupOrderProducts(
    order.orderProducts.map(formatOrderProduct)
  );

  return (
    <div className={classes.table}>
      <div className={classes.tableHeader}>
        <span>Qty.</span>
        <span>Product</span>
        <span>Price</span>
      </div>
      {orderProducts.map((op) => (
        <div key={op.uuid} className={classes.tableRow}>
          <span className={classes.cellQty}>{op.quantity}</span>
          <span className={classes.cellProduct}>{renderProductLabel(op)}</span>
          <span className={classes.cellPrice}>
            {formatPrice(parseFloat(op.price), currency)}
          </span>
        </div>
      ))}
    </div>
  );
}
